module.exports = __webpack_public_path__ + "img/wurlitzer_letters.191adbc6.png";